import React from 'react';
import { Container, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Volunteer } from '../models/types';
import VolunteerRegistrationForm from '../components/VolunteerRegistrationForm';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isAdmin } = useAuth();

  const handleSuccess = (volunteer: Volunteer) => {
    setTimeout(() => {
      if (isAdmin) {
        navigate('/admin');
      } else {
        navigate('/volunteer/dashboard');
      }
    }, 1500);
  };
  React.useEffect(() => {
    if (isAuthenticated) {
      if (isAdmin) {
        navigate('/admin');
      } else {
        navigate('/volunteer/dashboard');
      }
    }
  }, [isAuthenticated, isAdmin, navigate]);

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, mb: 4 }}>
        <VolunteerRegistrationForm onSuccess={handleSuccess} />
      </Box>
    </Container>
  );
};

export default LoginPage;

